// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./ManageBilling.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  RootPrimitive,
  SpacerPrimitive,
  TextPrimitive,
  ContainerPrimitive,
} from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      LD5qQJe8bP: {
        none: {
          text: "Billing",
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const ManageBillingContext = createContext(null);

function ManageBilling(_props) {
  const defaults = useContext(ManageBillingContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="C5Ld47ZcuS"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "C5Ld47ZcuS",
        scope: "G1jx1uRKPk",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"title_LD5qQJe8bP"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_G1jx1uRKPk_LD5qQJe8bP"
            }
            key={"LD5qQJe8bP"}
            text={
              exists(props.title) ? props.title : getStyle("LD5qQJe8bP", "text")
            }
            element={getStyle("LD5qQJe8bP", "htmlElement")}
          />
          <SpacerPrimitive
            id={"Spacer_6MTn41wXoh"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_G1jx1uRKPk_6MTn41wXoh"
            }
            key={"6MTn41wXoh"}
          />
          <ContainerPrimitive
            key={"RnSqXP2uN2"}
            id={"Slot_RnSqXP2uN2"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_G1jx1uRKPk_RnSqXP2uN2"
            }
            addSpacing={false}
          >
            {props.children}
          </ContainerPrimitive>
        </>
      )}
    </RootPrimitive>
  );
}

ManageBilling.__variants = [];

export default ManageBilling;
